import * as React from "react";
import { LuAlertCircle, LuSearch } from "react-icons/lu";
import validation from "./Validation";
import { InputMainStyle, InputLabelStyle, InputFormatLabelStyle, InputSearchStyle, InputStyle, InputLabelErrorMainStyle, InputLabelErrorTextStyle, InputLabelErrorIconStyle, InputLabelErrorAlertCicleStyle, InputErrorStyle, InputRequiredStyle } from "../styles/InputStyle";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  label?: string;
  formatlabel?: string;
  searchicon?: string;
  styled?: string | undefined  
}

const BaseInput = ({ error, ...rest }: InputProps) => (  
    <div
      className={rest.styled ? undefined : rest.className}
      style={rest.styled ?  InputMainStyle : undefined}
    >
      {rest.label &&
        <label
          className={rest.styled ? undefined : rest.className + '-label'}
          style={rest.styled ? InputLabelStyle : undefined}
        >
          {rest.label}
          {rest.required && <span style={InputRequiredStyle}>*</span>}
        </label>
      }
      {rest.formatlabel &&
        <label
          className={rest.styled ? undefined : rest.className + '-format-label'}
          style={rest.styled ? InputFormatLabelStyle : undefined}
        >
          {rest.formatlabel}
        </label>
      }
      {rest.searchicon &&
        <LuSearch
          className={rest.styled ? undefined : rest.className + '-icon'}
          style={rest.styled ? InputSearchStyle : undefined}
        />
      }      
      <input
        {...rest}
        className={rest.styled ? undefined : rest.className + ((error) ? '-red' : '-grey')}
        style={rest.styled ? (error ? InputErrorStyle : InputStyle) : undefined}
      />
      
      <label
        className={rest.styled ? undefined : rest.className + '-error'}
        style={rest.styled ? InputLabelErrorMainStyle : undefined}
      >
        {error &&
        <div
          className={rest.styled ? undefined : rest.className + '-error'}
          style={rest.styled ? InputLabelErrorTextStyle : undefined}
        >
          <div
            className={rest.styled ? undefined : rest.className + '-alert-icon'}
            style={rest.styled ? InputLabelErrorIconStyle : undefined}
          >
            <LuAlertCircle
              className={rest.styled ? undefined : rest.className + '-alert-circle'}
              style={rest.styled ? InputLabelErrorAlertCicleStyle : undefined}
            />
          </div>
          {error}
        </div>
        }
      </label>
    </div>
);

const Input = validation(BaseInput);

export default Input;
